import React from 'react';
import './style.scss';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { withTranslation } from 'react-i18next';
import Item from './Item';

const Quote = (props) => {
  if (!props?.fields || !props?.params) {
    return <GenericPlaceholder componentName="Search" />;
  }
  return (
    <>
      <div className={clsx('content', 'add-margins', props?.params?.Styles)}>
        <Item props={props} />
      </div>
    </>
  );
};

export default withTranslation()(Quote);
